import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import './datepicker2.css'

import 'react-datepicker/dist/react-datepicker.css';

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

class DatePicker2 extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
    this.state = {
      startDate: moment().toDate()
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.handleChange(this.state.startDate)
  }

  handleChange(date) {
    console.log("date",date)
    let indate = moment(date).startOf('day')
    if(indate > moment(Date.now())){
        indate = moment(Date.now())
        this.setState({
            startDate: indate
          });
    }else {
        this.setState({
            startDate: moment(date).startOf('day').toDate()
          });
    }
    
    this.props.onChange(indate)
  }

  render() {
    return <div>
      {/* {console.log("frm date picker2",this.state.startDate)} */}
        <DatePicker
        wrapperClassName="datepicker"
        selected={this.state.startDate}
        onChange={this.handleChange}
        dateFormat="dd-MM-yyyy"
        maxDate= {moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
    />
        </div>
  }
}
export default DatePicker2